/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};

  // Shared debounce timers across all mega menu instances
  var _openTimer = null;
  var _closeTimer = null;
  var OPEN_DELAY = 150;   // ms before opening (prevents flicker when passing over items)
  var CLOSE_DELAY = 200;  // ms before closing (allows moving from nav item into panel)

  Shopify.theme.jsMegaMenu = {
    init: function($section) {
      // Add settings from schema to current object
      Shopify.theme.jsMegaMenu = $.extend(this, Shopify.theme.getSectionData($section));
  
      // Selectors
      let timeout
      const parentLink = this.parent_link;
      const sectionId = this.section_id;
      const $megaMenu = $section.find('.mega-menu__' + sectionId);
      const $parentElement = $('.header__menu [data-navlink-handle="' + parentLink + '"], .sticky-header__menu [data-navlink-handle="' + parentLink + '"]');
      const $parentElementLink = $parentElement.children('.header__link');
      // Remove old mega menus
      $parentElement.find('.mega-menu__section').remove();
  
      // Mobile Selectors
      const $parentMobileElement = $(`[data-mobile-menu-navlink-handle="${parentLink}"]`);
  
      /* No submenu is present - add mega menu elements and caret */
      if ($parentMobileElement.find('.has-no-submenu').length) {
  
        // Assign class to display dropdown arrow
        $parentMobileElement.find('a.mobile-menu__item, .fakelink').addClass('mobile-menu-link');
  
        // Insert close icon after menu item
        $parentMobileElement.find('a').after('<span class="close-dropdown" aria-expanded="false"></span>');
  
        // Insert placeholder ul for megamenu
        $parentMobileElement.find('.submenu__label').after('<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>')
  
        // Find data attribute for toggle and assign it true
        let $mobileMenuToggle = $parentMobileElement.find('[data-mobile-menu-has-toggle]');
        $($mobileMenuToggle).attr('data-mobile-menu-has-toggle', true);
  
  
        // Insert mega menu
        let $parentList = $parentMobileElement.find('.has-mega-menu');
        $megaMenu.clone().appendTo($parentList);
  
      } else {
        /* Submenu is present - add mega menu elements and remove current sub-menu */
        let $parentList = $parentMobileElement.find('[data-mobile-submenu-first-level-list]');
  
        $parentList
          .empty()
          .addClass('has-mega-menu')
          .removeClass('has-dropdown');
  
        // Insert mega menu
        $megaMenu.clone().appendTo($parentList);
      }
  
  
      // Desktop
      if ($parentElement.hasClass('header__item') || $parentElement.hasClass('vertical-header__first-level')) {
        // Hide default dropdown
        $parentElement.find('.navbar-dropdown').addClass('is-invisible is-hidden');
  
        // Add arrow to parent link to indicate dropdown
        $parentElementLink.removeClass('is-arrowless');
  
        $megaMenu.clone().appendTo('.vertical-header__first-level[data-navlink-handle="' + parentLink + '"], .header__item[data-navlink-handle="' + parentLink + '"]');
  
        // Add/remove classes for proper styling and append mega menu instance
        $parentElement.addClass('has-mega-menu')
      }
  
      // Determine if header is set to hover to open or click to open
      if ($('.dropdown-click--false').length > 0) {
        $('.navbar-item, .header__brand, .header__search').on('mouseenter', function(){
          var $this = $(this);

          // Cancel any pending close
          if (_closeTimer) { clearTimeout(_closeTimer); _closeTimer = null; }

          // Color change is instant — apply is-hover-active to link immediately
          $('.navbar-item > .header__link').removeClass('is-hover-active');
          if ($this.hasClass('has-mega-menu')) {
            $this.children('.header__link').addClass('is-hover-active');
          }

          // Debounce panel open only — so passing over items doesn't flash panels
          if (_openTimer) { clearTimeout(_openTimer); }
          _openTimer = setTimeout(function() {
            $('.mega-menu__section').removeClass('is-active');
            if ($this.hasClass('has-mega-menu')) {
              $this.find('.mega-menu__section').addClass('is-active');
            }
          }, OPEN_DELAY);
        });

        $('.mega-menu__section, .navbar, .navbar-item, .header__brand').on('mouseleave', function(){
          // Cancel any pending open
          if (_openTimer) { clearTimeout(_openTimer); _openTimer = null; }

          // Debounce panel close: allow cursor to travel from nav item into panel
          var closeId = {};
          _closeTimer = closeId;
          setTimeout(function() {
            if (_closeTimer !== closeId) return; // cancelled
            _closeTimer = null;
            $('.mega-menu__section').removeClass('is-active');
            // Remove color after transition completes (0.3s)
            setTimeout(function() {
              if (_closeTimer !== null) return; // re-entered before color cleared
              $('.navbar-item > .header__link').removeClass('is-hover-active');
            }, 300);
          }, CLOSE_DELAY);
        });

        // Entering the mega panel cancels the close timer and restores link color
        $('.mega-menu__section').on('mouseenter', function() {
          _closeTimer = null; // cancel pending close
          var $owningItem = $(this).closest('.navbar-item');
          if ($owningItem.length) {
            $owningItem.children('.header__link').addClass('is-hover-active');
          }
        });
      } else {
        $('.navbar-item, .header__brand, .header__search').on('click touchstart', function(){
  
          //Close any mega menus on click
          $('.mega-menu__section').removeClass('is-active');
  
          if($(this).hasClass('has-mega-menu')) {
  
            //Toggle corresponding mega menu
            $(this).find('.mega-menu__section').addClass('is-active');
          }
        })
      }
    },
    showThemeEditorState: function(id, $section) {
      $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--force-show');
      $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').addClass('is-active');
    },
    hideThemeEditorState: function(id, $section) {
      $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--force-show');
      $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').removeClass('is-active');
    },
    displayMenu: function(id) {
      $('.mega-menu').removeClass('mega-menu--show');
      $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--show');
    },
    hideMenu: function(id) {
      $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--show');
    },
    unload: function($section) {
      let parentLink = $section.find('.mega-menu').data('parent-link');
      let navLink = $('[data-navlink-handle="' + parentLink + '"]')
      navLink.off();
      navLink.find('.mega-menu__section').remove();
      $('.mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search').off();
    }
  }
  
  /******/ })()
  ;